import { useEffect, useState } from 'react'

/**
 * Returns `value` delayed by `delayMs` — it only updates once `value` has been
 * stable for that long. Standard debounce for search inputs and other rapidly
 * changing values that drive expensive work (network requests, query keys).
 */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs)
    return () => clearTimeout(handle)
  }, [value, delayMs])
  return debounced
}
